const FINNISH_LOCALE = "fi-FI";
const FINNISH_TIME_ZONE = "Europe/Helsinki";

export const formatUtcAsFinnishDateTime = (value?: string | null): string => {
  if (!value) return "-";

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return "-";

  const datePart = parsed.toLocaleDateString(FINNISH_LOCALE, {
    timeZone: FINNISH_TIME_ZONE,
  });

  const timeParts = new Intl.DateTimeFormat(FINNISH_LOCALE, {
    timeZone: FINNISH_TIME_ZONE,
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).formatToParts(parsed);

  const hours = timeParts.find((part) => part.type === "hour")?.value ?? "00";
  const minutes =
    timeParts.find((part) => part.type === "minute")?.value ?? "00";

  return `${datePart} ${hours}:${minutes}`;
};
